import { AntDesign } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { useSaleControllerProvider } from "../../../../utils/sale-controller";
import { QuickKey as BaseQuickKey } from "../../../QuickKey";

export type SwitchSaleQuickKeyProps = {};

export const SwitchSaleQuickKey = React.forwardRef<
  any,
  SwitchSaleQuickKeyProps
>(({ ...props }, ref) => {
  const { sale } = useSaleControllerProvider();
  const { colors: Colors } = useTheme();
  const navigation = useNavigation<SellScreenProps["navigation"]>();

  const onPress = useCallback(() => {
    navigation.navigate("ActionsRootScreen", {
      screen: "SwitchSaleScreen",
    });
  }, [sale]);

  return (
    <BaseQuickKey
      ref={ref}
      label="Switch Sale"
      isDestructive={false}
      onPress={onPress}
      isAction={true}
      backgroundColor={Colors.action}
      iconPrimary={
        <AntDesign name="swap" size={24} color={Colors.quickKeyActionIcon} />
      }
      {...props}
    />
  );
});
